var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CandidateInfoCard',{attrs:{"id":_vm.timesheet.candidate.id,"name":_vm.timesheet.candidate.name,"email":_vm.timesheet.candidate.email,"phone-numbers":_vm.compPhoneNumberList}})}
var staticRenderFns = []

export { render, staticRenderFns }